"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _axios = _interopRequireDefault(require("axios"));

var _react = require("react");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _GeneralButton = require("../../atoms/GeneralButton");

var _addVersion = _interopRequireDefault(require("../../../assets/images/versionSelector/addVersion.svg"));

var _closeVersionSelector = _interopRequireDefault(require("../../../assets/images/versionSelector/closeVersionSelector.svg"));

var _variables = require("../../../../dist/global-files/variables");

var _variables2 = require("../../../global-files/variables");

var _VersionItem = require("../../molecules/VersionItem");

var _CreateVersion = require("../../organisms/CreateVersion");

var _customHooks = require("../../../global-files/customHooks");

var _jsxRuntime = require("react/jsx-runtime");

var VersionSelector = function VersionSelector(_ref) {
  var modalId = _ref.modalId,
      articleId = _ref.articleId,
      setVersion = _ref.setVersion,
      companyName = _ref.companyName,
      currentVersion = _ref.currentVersion,
      setShowVersionSelector = _ref.setShowVersionSelector,
      jwt = _ref.jwt;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      versions = _useState2[0],
      setVersions = _useState2[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)("create-version"),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showCreateVersion = _useCloseModal2[0],
      setShowCreateVersion = _useCloseModal2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      reload = _useState4[0],
      setReload = _useState4[1];

  var loadProductVersions = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(articleId) {
      var response, versionList;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios.default.get("".concat(process.env.REACT_APP_VERSIONS_ENDPOINT, "?articleId=").concat(articleId, "&provider=true"), {
                headers: {
                  Authorization: jwt
                }
              });

            case 3:
              response = _context.sent;
              versionList = JSON.parse(response.data.body).data;
              setVersions(versionList);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function loadProductVersions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var ac = new AbortController();
    loadProductVersions(articleId);
    return function () {
      setVersions([]);
      setShowCreateVersion(false);
      return function () {
        return ac.abort();
      }; // Abort both fetches on unmount
    };
  }, [reload]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: modalId,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "versions-header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        text: "Versión del producto",
        headerType: "input-name-header",
        color: _variables.GlobalColors.white,
        fontFamily: _variables2.FontFamily.Lato
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "buttons-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
          image: _addVersion.default,
          buttonType: "circular-button",
          onClick: function onClick() {
            return setShowCreateVersion(true);
          },
          id: "add-version"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
          image: _closeVersionSelector.default,
          buttonType: "circular-button",
          onClick: function onClick() {
            return setShowVersionSelector(false);
          },
          id: "close-button"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "versions-container",
      children: versions === null || versions === void 0 ? void 0 : versions.map(function (item) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionItem.VersionItem, {
          version: item.version,
          articleStatus: item.article_status,
          currentVersion: item.version === currentVersion,
          productOwner: companyName,
          setVersion: setVersion,
          timestamp: item.timestamp
        }, item.version);
      })
    }), showCreateVersion && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CreateVersion.CreateVersion, {
      articleId: articleId,
      version: currentVersion,
      versionsList: versions,
      setShowCreateVersion: setShowCreateVersion,
      realoadVersion: function realoadVersion() {
        return setReload(!reload);
      },
      jwt: jwt
    })]
  });
};

exports.VersionSelector = VersionSelector;